import { SWReactCountryIcons } from "@similarweb/icons";

import CountryService from "app/services/CountryService";

import * as SC from "./styles";

type CountrySchema = {
    countryCode: number;
    dataAutomation?: string;
};

export const Country = ({ countryCode, dataAutomation }: CountrySchema) => {
    const countryText = CountryService.getCountryById(countryCode)?.text;

    return (
        <SC.HeaderItemContainer data-automation={dataAutomation}>
            <SWReactCountryIcons
                countryCode={countryCode}
                size="xs"
            />

            <SC.HeaderItemText>{countryText}</SC.HeaderItemText>
        </SC.HeaderItemContainer>
    );
};
